<template>
  <div class="custom-cards-resultado-coletivo">
    <div class="custom-header">
      <p class="p-16-custom dark-0">
        {{ this.$props.title }}
      </p>
    </div>
    <div class="custom-body">
      <div class="w-100">
        <p
          v-text="this.$props.infoDetail"
          class="custom-text-align p-16-custom"
          :class="onGetClassCustomColor()"
        ></p>
        <div class="config-div-detail">
          <img
            v-if="this.$props.showImgMeta"
            class="img-meta"
            src="../../../assets/images/MDI-arrow-down-bold.svg"
          />
          <img
            v-if="this.$props.goalExceeded"
            class="img-meta"
            src="../../../assets/images/MDI-party-popper.svg"
          />
          <p
            v-text="this.$props.infoValue"
            class="custom-text-align config-size-value ml-3 info-value-style"
            :class="onGetClassCustomColor()"
          ></p>
        </div>
        <p v-if="this.$props.infoSaibaMais" :class="onGetClassInfoPorcentage()"> {{ this.$props.infoSaibaMais }}</p>
      </div>
    </div>
    <div v-if="this.$props.typeAction" class="custom-footer">
      <p
        class="p2 primary custom-pointer"
        @click="onActioHandler(typeActionHandler, titleHandler)"
      >
        <img
          class="img-learn-more"
          src="../../../assets/images/MDI-information-new.svg"
        />
        Saiba mais
      </p>
    </div>
  </div>
</template>

<script>
import { isMobile } from '../../../utils/mobile/mobile';

export default {
  props: [
    "title",
    "customColor",
    "infoValue",
    "infoSaibaMais",
    "onAction",
    "typeAction",
    "infoDetail",
    "showImgMeta",
    "goalExceeded"
  ],
  setup(props) {
    const onActioHandler = function(type, title) {
      props.onAction(type, title);
    };

    return { onActioHandler };
  },
  data() {
    return {
      typeActionHandler: "",
      titleHandler: "",
    }
  },
  components: {},
  mounted() {
    this.typeActionHandler = this.$props.typeAction ? this.$props.typeAction : "";
    this.titleHandler = this.$props.title ? this.$props.title : "";
  },
  methods: {
    onGetClassCustomColor() {
      return this.$props.customColor;
    },
    onGetClassInfoPorcentage() {
      let resp = "p-16-custom "
      if (isMobile()) {
        return resp + "p-4-m " + this.onGetClassCustomColor()
      }

      return resp + this.onGetClassCustomColor();
    }
  }
};
</script>
<style lang="scss" scoped>
.custom-cards-resultado-coletivo {
  border-radius: 10px;
  background-color: #ffffff;
  padding-left: 1.2rem;
  padding-right: 1.2rem;
  padding-top: 1.2rem;
  padding-bottom: 1.2rem;
  width: 100%;
  height: 14.5rem;
}
.custom-header {
  height: 20%;
}
.custom-body {
  height: 60%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.custom-footer {
  height: 20%;
}
.img-learn-more {
  height: 1.4rem;
  width: 1.4rem;
}
.custom-pointer {
  cursor: pointer;
}
.custom-title {
  font-size: multiplier-default-font-size(3); // 16
}
.config-size-value {
  font-size: multiplier-default-font-size(13); // 36
}
.p-16-custom {
  font-size: multiplier-default-font-size(3); // 16
}
.primary {
  color: var(--primary);
}
@media (max-width: 992px) {
  .p-16-custom {
    font-size: multiplier-default-font-size(2); // 14
  }

  .custom-cards-resultado-coletivo {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
}
.dark-0 {
  color: var(--dark-0);
}
.custom-text-align {
  text-align: end;
}
.green-3 {
  color: var(--green-3);
}
.orange-2 {
  color: var(--orange-2);
}
.config-div-detail {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-content: center;
}
.img-meta {
  height: 3.1rem;
  width: 3.1rem;
}
.info-value-style {
  font-weight: bold;
}
</style>
